export default function Title({ title }) {
  return (
    <div className="title mb-5">
      <p className="text-xl font-bold text-[#144677]">{title}</p>
      <div className="w-24 h-1 mt-1 rounded-lg bg-[#FF6266]"></div>
    </div>
  );
}
